export class PosthogStore {
  private _initialized = false;

  isInitialized() {
    return this._initialized;
  }

  setInitialized(value: boolean) {
    this._initialized = value;
  }

  reset() {
    this._initialized = false;
  }
}

const posthogStore = new PosthogStore();

export default posthogStore;
